import { css } from "lit";

export const appStyles = css`
  :host {
    display: block;
    min-height: 100vh;
    padding: 24px 16px 48px;
    font-family:
      system-ui,
      -apple-system,
      sans-serif;
    transition:
      background 0.3s,
      color 0.3s;
  }

  .content {
    max-width: 960px;
    margin: 0 auto;
  }

  .banner-slot {
    height: 32px;
    margin-bottom: 16px;
    display: block;
    position: relative;
  }

  .icon-btn-group {
    display: flex;
  }

  .icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 30px;
    padding: 0;
    background: var(--bab-button-secondary-bg, #fff);
    color: var(--bab-button-secondary-text, #4a90e2);
    border: var(--bab-border-width, 1.5px) solid var(--bab-border);
    cursor: pointer;
    transition: background 0.15s;
  }

  .icon-btn:first-child {
    border-radius: var(--bab-radius, 12px) 0 0 var(--bab-radius, 12px);
    border-right: none;
  }

  .icon-btn:last-child {
    border-radius: 0 var(--bab-radius, 12px) var(--bab-radius, 12px) 0;
  }

  .icon-btn:hover:not(:disabled) {
    background: var(--bab-bg, #f0f4f8);
  }

  .icon-btn:focus-visible {
    outline: 2px solid var(--bab-accent, #4a90e2);
    outline-offset: 2px;
  }

  .icon-btn:disabled {
    opacity: 0.4;
    cursor: default;
  }

  .icon-btn svg {
    width: 16px;
    height: 16px;
  }

  .submit-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 30px;
    padding: 0 14px;
    background: var(--bab-accent, #4a90e2);
    color: #fff;
    border: var(--bab-border-width, 1.5px) solid var(--bab-border);
    border-radius: var(--bab-radius, 12px);
    font-size: 0.8rem;
    font-weight: var(--bab-font-weight, 600);
    font-family: inherit;
    cursor: pointer;
    white-space: nowrap;
    transition: opacity 0.15s;
  }

  .submit-btn:hover:not(:disabled) {
    opacity: 0.88;
  }

  .submit-btn:focus-visible {
    outline: 2px solid var(--bab-accent, #4a90e2);
    outline-offset: 2px;
  }

  .submit-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .submit-btn svg {
    width: 14px;
    height: 14px;
  }

  .layout {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .raters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px 8px;
    margin-top: -8px;
    border-bottom: var(--bab-border-width) solid var(--bab-border);
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--bab-card-bg);
    border-radius: var(--bab-radius) var(--bab-radius) 0 0;
  }

  .raters-title {
    font-size: 0.7rem;
    font-weight: var(--bab-font-weight);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--bab-text-secondary);
  }

  .completion-badge {
    font-size: 0.7rem;
    font-weight: var(--bab-font-weight);
    color: var(--bab-text-secondary);
    transition: color 0.2s;
  }

  .completion-badge--complete {
    color: #22c55e;
  }

  .raters-panel {
    background: var(--bab-card-bg);
    border: var(--bab-border-width) solid var(--bab-border);
    border-radius: var(--bab-radius);
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.08),
      0 4px 12px rgba(0, 0, 0, 0.04);
    overflow: clip;
    position: relative;
    padding: 12px 0;
  }

  /* Locked overlay for raters-panel */
  .raters-panel--locked::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.03);
    pointer-events: none;
    z-index: 10;
  }

  .raters-panel bab-attribute-rater {
    display: block;
    padding: 20px 16px 16px;
    border-bottom: 1px dashed var(--bab-border);
    transition: background 0.1s;

    /* Propagation */
    --bab-label-color: var(--bab-text);
    --bab-description-color: var(--bab-text-secondary);
    --bab-button-border: var(--bab-border);
    --bab-button-bg: var(--bab-card-bg);
    --bab-button-color: var(--bab-text);
    --bab-accent: var(--bab-accent);
    --bab-rating-label-color: var(--bab-text-secondary);
    --bab-border-width: var(--bab-border-width);
    --bab-radius: var(--bab-radius);
    --bab-font-weight: var(--bab-font-weight);
  }

  .raters-panel bab-attribute-rater:last-of-type {
    border-bottom: none;
  }

  .raters-panel bab-attribute-rater:not([disabled]):hover {
    background: var(--bab-bg);
  }

  .group-header {
    padding: 14px 16px 4px;
    font-size: 0.65rem;
    font-weight: var(--bab-font-weight, 600);
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: var(--bab-text-secondary);
  }

  bab-attribute-rater + .group-header {
    border-top: 1px dashed var(--bab-border);
    margin-top: 4px;
  }

  .chart-panel {
    background: var(--bab-card-bg);
    border: var(--bab-border-width) solid var(--bab-border);
    border-radius: var(--bab-radius);
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.08),
      0 4px 12px rgba(0, 0, 0, 0.04);
    padding: 20px;
    transition: box-shadow 0.2s;
    order: -1;
    position: relative;
  }

  .chart-panel--expanded {
    z-index: 6000;
  }

  .chart-panel:hover {
    box-shadow:
      0 2px 6px rgba(0, 0, 0, 0.1),
      0 8px 20px rgba(0, 0, 0, 0.06);
  }

  /* Desktop layout overrides (Precedence fix) */
  @media (min-width: 700px) {
    .layout {
      grid-template-columns: 1fr 2fr;
      align-items: start;
      gap: 24px;
    }
    .chart-panel {
      position: sticky;
      top: 24px;
      order: 0;
    }
  }

  .app-footer {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    padding-top: 16px;
  }

  .footer-link {
    background: none;
    border: none;
    padding: 4px 8px;
    font-size: 0.8rem;
    font-family: inherit;
    color: var(--bab-text-secondary);
    text-decoration: underline;
    cursor: pointer;
  }

  .footer-link:hover {
    color: var(--bab-text);
  }

  .footer-link:focus-visible {
    outline: 2px solid var(--bab-accent, #4a90e2);
    outline-offset: 2px;
  }

  /* ─── Skeleton loaders ─── */
  @keyframes skeleton-pulse {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0.45; }
  }

  .skeleton-base {
    background: var(--bab-border);
    border-radius: 4px;
    animation: skeleton-pulse 1.5s ease-in-out infinite;
  }

  /* Name bar skeleton */
  .skeleton-name {
    height: 44px;
    margin-bottom: 16px;
    border-radius: var(--bab-radius);
    width: 220px;
  }

  /* Per-attribute rater skeleton */
  .skeleton-rater {
    padding: 20px 16px 16px;
    border-bottom: 1px dashed var(--bab-border);
  }

  .skeleton-rater:last-child {
    border-bottom: none;
  }

  .skeleton-rater__name {
    height: 11px;
    width: 42%;
    margin-bottom: 12px;
  }

  .skeleton-rater__track {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
  }

  .skeleton-rater__node {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .skeleton-rater__segment {
    flex: 1;
    height: 2px;
  }

  .skeleton-rater__labels {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
  }

  .skeleton-rater__label {
    height: 9px;
    width: 55px;
  }

  /* Spider chart skeleton */
  .skeleton-chart {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    aspect-ratio: 1;
    width: 100%;
    box-sizing: border-box;
  }

  .skeleton-chart__circle {
    width: 85%;
    aspect-ratio: 1;
    border-radius: 50%;
  }
`;
